import styled from "@emotion/styled";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/dist/client/router";
import React from "react";
import { default as DownSVG } from "../assets/arrow-down.svg";

interface Props {
  href?: string;
}

const BackButton = ({ href }: Props) => {
  const { t } = useTranslation("common");
  const { back, push } = useRouter();

  const handleClick = () => {
    if (href) {
      push(href);
    } else {
      back();
    }
  };

  return (
    <Button onClick={handleClick} aria-label="back">
      <BackArrow />
      <Text>{t("back")}</Text>
    </Button>
  );
};

const Button = styled.button`
  background: none;
  border: none;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  cursor: pointer;
  margin-top: 64px;
  padding-left: 0;
`;

const Text = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: 700;
  text-transform: uppercase;
`;

const BackArrow = styled(DownSVG)`
  width: 24px;
  transform: rotate(90deg);
  margin-right: 16px;
`;

export default BackButton;
